import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import WhatsAppFloat from "../common/WhatsAppFloat";

export default function Layout({ children }) {
    const { pathname } = useLocation();
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "instant" });
    }, [pathname]);

    return (
        <div className="min-h-screen flex flex-col bg-transparent">
            <Header />
            <main className="flex-1 bg-transparent">{children}</main>
            <Footer />
            <WhatsAppFloat />
        </div>
    );
}
